import React, { Fragment, useState } from 'react'
import { makeStyles } from '@mui/styles'
import Card from '@mui/material/Card'
import CardContent from '@mui/material/CardContent'
import { IconButton, Tooltip } from '@mui/material'
import VisibilityIcon from '@mui/icons-material/Visibility'
import { Modal } from '../../Modal/Modal'
import { WorkOrderFillRateDetailViewer } from '../WorkOrderFillRateViewer/WorkOrderFillRateDetailViewer'
import { DataGridSettings } from '../../../interfaces/DataGrid/DataGridSettings'
import { DataGridColumn } from '../../DataGrid/DataGridColumn'
import { DataGridRow } from '../../DataGrid/DataGridRow'
import { CellText } from '../../DataGrid/CellText'
import { FillRateData } from '../../../interfaces/DashBoard/FillRate'

const useStyles = makeStyles(() => ({
  root: {
    display: 'flex',
    paddingBottom: '0px'
  },
  details: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%'
  },
  content: {
    flex: 'auto',
    paddingBottom: '0px'
  }
}))

interface GridElementFillRateProps {
  element: FillRateData
  dataGridSettings: DataGridSettings
}

export const GridElementFillRate: React.FC<GridElementFillRateProps> = ({
  element,
  dataGridSettings
}) => {
  const [showModal, setShowModal] = useState<boolean>(false)

  const classes = useStyles()

  return (
    <Fragment>
      <Card className={`${classes.root}`}>
        <div className={classes.details}>
          <CardContent
            className={classes.content}
            style={{ paddingBottom: '0px' }}
          >
            <DataGridRow settings={dataGridSettings}>
              <DataGridColumn
                datafield='workOrderId'
                settings={dataGridSettings}
              >
                <CellText text={element.workOrderId} />
              </DataGridColumn>

              <DataGridColumn datafield='fillrate' settings={dataGridSettings}>
                <CellText text={`${element.fillrate.toString()}%`} />
              </DataGridColumn>

              <DataGridColumn datafield='realQty' settings={dataGridSettings}>
                <CellText text={element.realQty.toString()} />
              </DataGridColumn>

              <DataGridColumn
                datafield='column-buttons'
                settings={dataGridSettings}
              >
                <Tooltip title='Ver Detalle' aria-label='detalle'>
                  <IconButton
                    aria-label='view'
                    onClick={() => setShowModal(true)}
                    style={{ marginTop: '-12px' }}
                  >
                    <VisibilityIcon />
                  </IconButton>
                </Tooltip>
              </DataGridColumn>
            </DataGridRow>
          </CardContent>
        </div>
      </Card>
      <Modal funcClose={() => setShowModal(false)} isOpen={showModal}>
        <WorkOrderFillRateDetailViewer workOrderId={element.workOrderId} />
      </Modal>
    </Fragment>
  )
}
